export enum LanguagesEnum {
  brazilianPortuguese = "pt-BR",
  americanEnglish = "en-US",
  spanish = "es-ES",
}
